import classnames from 'classnames';
import React from 'react';

const CSS = require('./Paragraph.module.scss');

interface ParagraphProps {
  children: any;
  className?: string;
  size?: 'small' | 'medium';
  [key: string]: any;
}

function Paragraph({ children, className, size, ...rest }: ParagraphProps) {
  const classes = classnames(CSS.Paragraph, {
    [className]: !!className,
  });

  return (
    <p className={classes} data-size={size} {...rest}>
      {children}
    </p>
  );
}

export default Paragraph;
